import React, {Component, createRef} from 'react'
import {withTranslation} from 'react-i18next'
import {withRouter} from 'react-router-dom'
import {connect} from 'react-redux'

import UserMenu from './UserMenu'
import SubHeader from './SubHeader'
import Navigation from '../navigation'
import Notifications from './Notifications'
import {Col} from '@amzn/stencil-react-components/layout'
import {H1, Text} from "@amzn/stencil-react-components/text";
import {MessageBanner, MessageBannerType, MessageBannerLink} from '@amzn/stencil-react-components/message-banner'

class Header extends Component {
  constructor(props) {
    super(props);
    this.title = createRef();
  }

  render() {
    const {t, degradedMessage, degradedLinkUrl, degradedLinkText} = this.props;

    return (
      <Col gridGap="S400">
        <UserMenu/>
        {degradedMessage &&
          <MessageBanner type={MessageBannerType.Warning}>
            <Text>{degradedMessage}{degradedLinkUrl && ' '}
              {degradedLinkUrl &&
                <MessageBannerLink href={degradedLinkUrl} target="_blank">{degradedLinkText}</MessageBannerLink>
              }
            </Text>
          </MessageBanner>
        }
        <H1 tabIndex="-1" ref={this.title}>{t('Header.Title')}</H1>
        <SubHeader/>
        <Notifications/>
        <Navigation/>
      </Col>
    )
  }
}

const mapState = (state) => ({
  degradedMessage: state.maintenance.degraded_message,
  degradedLinkUrl: state.maintenance.degraded_link_url,
  degradedLinkText: state.maintenance.degraded_link_text
});

export default withRouter(connect(mapState)(withTranslation('translationsV2')(Header)))
